import { Avatar, Button, Divider, notification } from "antd";
import React from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import "./TopNavbar.css";
import { MenuOutlined, LogoutOutlined } from "@ant-design/icons";

import { Link, useNavigate } from "react-router-dom";
import "../../Assets/Css/Global.css";
import { LogOutApi } from "../../Services/Login";

export default function TopNavbar() {
  const [api, contextHolder] = notification.useNotification();

  const handleLogout = async () => {
    try {
      const data = await LogOutApi();
      localStorage.clear();
      sessionStorage.clear();
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        document.cookie =
          name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      });
      // navigate("/auth", { replace: true });
      window.location.href = "/auth";
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Navbar
        expand="lg"
        className="navbar-style mb-2 px-4 py-0 h-[70px] shadow-md"
      >
        <div className="w-[220px] pt-2 pb-2 h-[63px]">
          <img
            src="/logo.png"
            alt="DJT Logo"
            className="w-full h-full object-contain"
          />
        </div>

        <Nav>
          <NavDropdown
            title={
              <Avatar className="bg-info">
                <span className="fw-bold">
                  {localStorage.getItem("firstName") !== null &&
                    `${localStorage.getItem("firstName")[0]}`}
                </span>
              </Avatar>
            }
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item onClick={handleLogout}>
              <LogoutOutlined
                className="mr-2"
                style={{ verticalAlign: "text-middle" }}
              />
              <span>Log Out</span>
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
        {/* </Navbar.Collapse> */}
      </Navbar>
    </>
  );
}
